import axios from "axios";

// Prefer same-origin API in production (Cloudflare Pages) to avoid hardcoding localhost.
// If REACT_APP_BACKEND_URL is set at build time, use it; otherwise use relative "/api".
const raw = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/^"+|"+$/g, "").replace(/\/+$/, "");
export const API = raw ? `${raw}/api` : "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Token fallback (used in addition to httpOnly cookie)
const tokenKey = "gegee_token";
export const setToken = (t) => { if (t) localStorage.setItem(tokenKey, t); else localStorage.removeItem(tokenKey); };
export const getToken = () => localStorage.getItem(tokenKey);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
